<template>
  <div>
    <b-button
      class="bot-client-button"
      size="sm"
      variant="info"
      @click="Toggle"
    >
      <b-icon-chat-dots-fill />
    </b-button>
    <div
      v-if="modal"
      class="bot-client-container"
      :style="{ right: right + 'px', display: display }"
    >
      <iframe class="bot-client-modal" src="https://sgb.hihi2u.com/"></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BotClient',
  mounted() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    
    window.addEventListener('resize', () => {
      // We execute the same script as before
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    });
  },
  data() {
    return {
      modal: false,
      right: -600,
      display: 'none'
    };
  },
  methods: {
    Toggle() {
      this.modal = true;
      this.display = 'block';
      if (this.right === 10) {
        this.right = -600;
      } else {
        this.right = 10;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.bot-client-button {
  position: fixed;
  top: 60px;
  right: 10px;
  z-index: 20;
}
.bot-client-modal {
  width: 100%;
  height: 80vh;
  height: calc(var(--vh, 1vh) * 80);
  border: none;
  border-radius: 10px;
}
.bot-client-container {
  position: fixed;
  top: 92px;
  height: 82vh;
  height: calc(var(--vh, 1vh) * 82);
  max-width: 500px;
  width: 95vw;
  padding: 5px;
  border: 2px solid #ebebeb;
  border-radius: 5px;
  z-index: 10;
  background-color: #fefefe;
  // -moz-box-shadow:    -1px 3px 5px 6px #ccc;
  // -webkit-box-shadow: -1px 3px 5px 6px #ccc;
  // box-shadow:         -1px 3px 5px 6px #ccc;
}
</style>
